import React, {useState, useEffect} from 'react';
import WelcomeWrapper from './wrappers/welcome-wrapper/welcome-wrapper.jsx';
import AboutWrapper from './wrappers/about-wrapper/about-wrapper.jsx';
import {Routes, Route, Link, useNavigate } from 'react-router-dom';

import AppData from './app-data.js'

import './App.css';
import 'dotenv/config'

const  App = () => {
  
  const navigate = useNavigate()
  const [navCollapse, setNavCollapse] = useState("")
  const [toggleMobileNav, setToggleMobileNav] = useState(false)
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if(typeof window !== 'undefined'){
      const handleResize = () => {
        setIsMobile(window.innerWidth < 768); // Example breakpoint
      };

      // Set initial state on mount
      handleResize();

      // Add event listener for window resize
      window.addEventListener('resize', handleResize);

      // Clean up event listener on unmount
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }
  }, []); 

  const toggleNav = () => {
    if (navCollapse === "") {
      setNavCollapse("show")
      setToggleMobileNav(true)
    } else {
      setNavCollapse("")
      setToggleMobileNav(false)
    }
  }


  return (
    <div className="full-height flex-div">
      {toggleMobileNav?
      <div className="mobile-menu slide-down" onClick={() => toggleNav()}>
        <i class="mobile-close-menu fas fa-window-close"></i>
        <div className={`collapse navbar-collapse show`} id="navbarText">
          <ul className="navbar-nav me-auto mb-2 mb-lg-0">
            <li className="nav-item center">
              <Link className="nav-link active mobile-link" to="/">
                <img className="logo-mobil-link-img popout-slow" src={AppData.logo} alt="Serene Manor Logo" />
              </Link>
            </li> 
            <li className="nav-item center popout-slow">
              <Link className="nav-link active mobile-link" to="/">Home</Link>
              
            </li>
            <li className="nav-item center popout-slow">
              <Link className="nav-link active mobile-link" to="/about-us">About</Link>
            </li>
          </ul>
        </div>
      </div> : ""}

      {!toggleMobileNav?
      <nav className={`navbar navbar-expand-lg nav-links-wrapper ${isMobile? `navbar-light bg-light` : `navbar-dark bg-dark` }`}>
        <div className="container-fluid">
          <button 
            className="navbar-toggler" type="button" data-bs-toggle="collapse" 
            data-bs-target="#navbarText" aria-controls="navbarText" 
            aria-expanded="false" aria-label="Toggle navigation"
            onClick={() => toggleNav()}>
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className={`collapse navbar-collapse ${navCollapse}`} id="navbarText">
            <ul className="navbar-nav w-100 mb-2 mb-lg-0">
              <li className="nav-item me-auto">
                {/* <Link className="nav-link active" to="/">Home</Link> */}
                <Link className="nav-link active" to="/">
                  <img className="logo-link-img" src={AppData.logo} alt="Serene Manor Logo" />
                </Link>
              </li> 
              <li className="nav-item">
                <Link className="nav-link active" to="/about-us">About Us</Link>
              </li>
            </ul>
          </div>
        </div>
      </nav> : ""
      }

      {!toggleMobileNav?
      <main role="main">
        <Routes>
          <Route path="/about-us" element={<AboutWrapper data={AppData} isMobile={isMobile} />} />
          <Route path="*" element={<WelcomeWrapper data={AppData} isMobile={isMobile} />} />
        </Routes>
      </main> : ""
      }
    </div>
  );

}

export default App
